/* eslint-disable promise/no-return-wrap */
const crypto = require('crypto');

const removeWebSafe = (safeEncodedString) => safeEncodedString.replace(/-/g, '+').replace(/_/g, '/');
const makeWebSafe = (encodedString) => encodedString.replace(/\+/g, '-').replace(/\//g, '_');
const decodeBase64Hash = (code) => (Buffer.from ? Buffer.from(code, 'base64') : Buffer.from(code, 'base64'));
const encodeBase64Hash = (key, data) => crypto.createHmac('sha1', key).update(data).digest('base64');

const googleSecret = require('../static/google_api_key.json').secret;

const sign = (path) => {
  const secret = googleSecret;
  const safeSecret = decodeBase64Hash(removeWebSafe(secret));
  const hashedSignature = makeWebSafe(encodeBase64Hash(safeSecret, path));
  return hashedSignature;
};

const apiGet = (path, query) => {
  const headers = new Headers();
  headers.append('Accept', 'application/json');

  const uri = encodeURI(`/maps/api/${path}/json?client=gme-nikeinc${query}`);
  const signature = sign(uri);
  const requestUrl = `https://maps.googleapis.com${uri}&signature=${signature}`;

  const request = new Request(requestUrl, { headers, method: 'GET' });

  return fetch(request)
    .then((res) => {
      if (res.status >= 200 && res.status < 300) {
        const contentLength = parseInt(res.headers.get('Content-Length'), 10);
        if (res.status === 204 || contentLength === 0) {
          return {};
        }
        return res.json();
      } else {
        const err = new Error(res.statusText);
        err.status = res.status;
        return res.json().then(
          (errBody) => {
            err.body = errBody;
            throw err;
          },
          // ignore a parsing error, and just throw the original
          () => Promise.reject(err),
        );
      }
    })
    .catch((err) => Promise.reject(err));
};

export const getStoreCoords = (storeData, noLanguage) => {
  let {
    address1,
    address2,
    address3,
    city,
    state,
    country,
  } = storeData.address;
  if (noLanguage !== true) {
    address1 = storeData.address.en.address1;
    address2 = storeData.address.en.address2;
    address3 = storeData.address.en.address3;
    city = storeData.address.en.city;
    state = storeData.address.en.state;
    country = storeData.address.en.country;
  }

  // Get store name for better geocoding accuracy
  const storeName = storeData.name || '';

  // Build address components, filtering out empty values
  // Include store name at the beginning for better context
  const addressComponents = [
    storeName,
    address1 ? address1.replace(/#/, '%23') : '',
    address2 || '',
    address3 || '',
    city || '',
    state === '' ? country : state,
  ].filter((component) => component !== '');

  const query = {
    address1: address1.replace(/#/, '%23'),
    city,
    state: state === '' ? country : state,
  };

  if (!(query.address1 === '' || query.city === '' || query.state === '')) {
    const addressString = addressComponents.join(',');
    return apiGet('geocode', `&address=${addressString}`)
      .then((loc) => {
        const location = { ...loc.results[0].geometry.location };
        return { calculating: false, lat: location.lat, lng: location.lng };
      })
      .catch(() => ({ calculating: false }));
  } else {
    return Promise.reject(new Error('Missing one or more of address line 1, city, or state/country'));
  }
};

export const getTimezone = ({ lat, lng }) => apiGet('timezone', `&location=${lat},${lng}&timestamp=${Date.now() / 1000}`)
  .then((res) => ({ status: res.status, timeZoneId: res.timeZoneId }))
  .catch((err) => err);

export const getCountry = async ({ latitude, longitude }) => (latitude && longitude) && apiGet('geocode', `&latlng=${latitude},${longitude}&result_type=country&timestamp=${Date.now() / 1000}`);
